export default "__VITE_ASSET__33970fc5__"